// Compatibility for briefs whose source explicitly belongs to the Suwon survey.
// Never infer a market from language, UI locale, or the prose of a title.
const SUWON_RUNS = new Set(['2026-10-24-01', '2026-10-25-01', '2026-10-25-02', '2026-10-25-03', 'creative-archive-2026-10-23']);
export function candidateMarket(candidate, batch) {
  const country = candidate.country || batch.country;
  const city = candidate.city || batch.city;
  if (country) return { country, city: city || null };
  if (SUWON_RUNS.has(batch.run_id)) return { country: 'KR', city: 'Suwon' };
  return { country: 'UNKNOWN', city: city || null };
}
export function queueItems(batches) {
  return batches.flatMap(batch => batch.candidates.map(candidate => ({ candidate, batch, market: candidateMarket(candidate, batch) })))
    .sort((a, b) => b.batch.date.localeCompare(a.batch.date) || b.batch.run_id.localeCompare(a.batch.run_id, undefined, { numeric: true }) || a.candidate.rank - b.candidate.rank);
}

export const cityLabel = city => ({ Suwon: '수원', LosAngeles: 'LA', 'Los Angeles': 'LA' }[city] || city);
